//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { drawCircles } from '../static/js/createCircles.js'
export default {
  data() {
    return {
      canvasWidth: 0,
      canvasHeight: 0,
      imageUrl: '',
      extension: '',
      buttonEnabled: true,
    }
  },
  mounted() {
    this.setCanvasSize()
  },
  methods: {
    setCanvasSize() {
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight
      if (windowHeight < windowWidth) {
        const calculatedHeight = this.$refs.canvasContainer.clientHeight
        this.setCanvasHeight(calculatedHeight)
        this.setCanvasWidth(calculatedHeight * 0.75)
      } else {
        const calculatedWidth = windowWidth - 40
        this.setCanvasWidth(calculatedWidth)
        this.setCanvasHeight(calculatedWidth * 1.333)
      }
    },
    setCanvasWidth(w) {
      this.canvasWidth = w
    },
    setCanvasHeight(h) {
      this.canvasHeight = h
    },
    drawCircles(type) {
      if (!this.buttonEnabled) {
        return
      }
      this.buttonEnabled = false
      this.extension = type
      drawCircles(this.saveImage, type)
    },
    saveImage(dataUrl) {
      this.buttonEnabled = true
      this.imageUrl = dataUrl
    },
  },
}
